import { useEffect, useMemo, useRef } from 'react';
import { Subject, switchMap, takeUntil, tap, throttleTime } from 'rxjs';
export var useThrottleAsync = function useThrottleAsync(_ref) {
  var update = _ref.update,
      onUpdated = _ref.onUpdated,
      _ref$duration = _ref.duration,
      duration = _ref$duration === void 0 ? 1000 : _ref$duration;
  var pendingPayloads = useRef(new Map());
  var payloadId = useRef(0);

  var _useMemo = useMemo(function () {
    var queue$ = new Subject();
    var finalised$ = new Subject();
    return {
      queue$: queue$,
      finalised$: finalised$
    };
  }, []),
      queue$ = _useMemo.queue$,
      finalised$ = _useMemo.finalised$;

  useEffect(function () {
    var controller = new AbortController();
    queue$.pipe(tap(function (payload) {
      pendingPayloads.current.set(payloadId.current++, payload);
    }), throttleTime(duration, undefined, {
      trailing: true,
      leading: false
    }), switchMap(function () {
      if (!controller.signal.aborted) {
        controller.abort();
        controller = new AbortController();
      }

      var executingPayloads = Array.from(pendingPayloads.current.values());
      var executingIds = Array.from(pendingPayloads.current.keys());
      return update(executingPayloads, controller)["finally"](function () {
        executingIds.forEach(function (id) {
          return pendingPayloads.current["delete"](id);
        });
      });
    }), takeUntil(finalised$)).subscribe(onUpdated);
    return function () {
      finalised$.next();
    };
  }, [queue$, finalised$, update, onUpdated, duration]);
  return {
    queue$: queue$,
    finalised$: finalised$
  };
};